/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as React from "react";
import { AbCheckbox as AbCheckboxImpl } from "abreact/input/AbCheckbox";

/**
 * The properties for an AbCheckbox.
 */

/**
 * The **AbCheckbox** component allows the user to toggle a value on or off.
 *
 * [[include:absdk/commons/ui/input/AbCheckbox.md]]
 */
export function AbCheckbox(props) {
  return /*#__PURE__*/React.createElement(AbCheckboxImpl, props);
}
//# sourceMappingURL=AbCheckbox.js.map
